import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";

import APIClient from "web_modules/APIClient";
import Money from "web_modules/Money";
import HurdleView from "underwriter_dashboard/shared/HurdleView";

import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import INCOME_SUMMARY_ORDER from "./constants";
import Row from "./Row";

require(`../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
income_summary.scss`);

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");
const { Button, Table } = require("react-bootstrap");

interface IProps extends HurdleProps {
  dispatch: Function;
}

class IncomeSummary extends React.Component<IProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      monthlyResidualIncome: 0,
    };
  }

  getOrderedIncomeItems() {
    const { app } = this.props;
    const { income_summary }: any = app;
    const { computed_monthly_other_income_summary } = app.decision;

    const items = income_summary.tax_summary.sections.concat(computed_monthly_other_income_summary);

    return _.sortBy(items, (item: any) => _.indexOf(INCOME_SUMMARY_ORDER, item.heading));
  }

  renderIncomeSummaryTable() {
    const { app } = this.props;
    const { qualification_year }: any = app.income_summary;
    const primary = app.decision.computed_monthly_primary_salaried_income_summary;
    const secondary = app.decision.computed_monthly_secondary_salaried_income_summary;
    const incomeItems = this.getOrderedIncomeItems();
    const showCurrent =
      qualification_year !== primary.current_year ||
      (secondary.current_year !== 0 && qualification_year !== secondary.current_year);
    return (
      <Table className="income-summary-table__table">
        <thead>
          <tr>
            <th>Income Source</th>
            {showCurrent && <th>{primary.current_year}</th>}
            <th>{`Qualification Year: ${qualification_year}`}</th>
            <th>Year 1</th>
            <th>Year 2</th>
            <th>Qualifying Income</th>
          </tr>
        </thead>
        <tbody>
          {qualification_year === primary.current_year ? (
            <Row
              heading="Primary Salaried Employment"
              showCurrent={showCurrent}
              ytd_total={parseFloat(primary.current_year_ytd)}
              year_minus_one_total={parseFloat(primary.previous_year)}
              year_minus_two_total={parseFloat(primary.two_years_ago)}
              monthly_total={parseFloat(primary.qualifying_income)}
            />
          ) : (
            <Row
              heading="Primary Salaried Employment"
              showCurrent={showCurrent}
              current_ytd_total={parseFloat(primary.current_year_ytd)}
              ytd_total={parseFloat(primary.previous_year)}
              year_minus_one_total={parseFloat(primary.two_years_ago)}
              year_minus_two_total={0}
              monthly_total={parseFloat(primary.qualifying_income)}
            />
          )}
          {qualification_year === secondary.current_year ? (
            <Row
              heading="Secondary Salaried Employment"
              showCurrent={showCurrent}
              current_ytd_total={0}
              ytd_total={parseFloat(secondary.current_year_ytd)}
              year_minus_one_total={parseFloat(secondary.previous_year)}
              year_minus_two_total={parseFloat(secondary.two_years_ago)}
              monthly_total={parseFloat(secondary.qualifying_income)}
            />
          ) : (
            <Row
              heading="Secondary Salaried Employment"
              showCurrent={showCurrent}
              current_ytd_total={parseFloat(secondary.current_year_ytd)}
              ytd_total={parseFloat(secondary.previous_year)}
              year_minus_one_total={parseFloat(secondary.two_years_ago)}
              year_minus_two_total={0}
              monthly_total={parseFloat(secondary.qualifying_income)}
            />
          )}
          {incomeItems.map((item, i) => (
            <Row
              key={i}
              heading={item.heading}
              showCurrent={showCurrent}
              current_ytd_total={0}
              ytd_total={parseFloat(item.ytd_total)}
              year_minus_one_total={parseFloat(item.year_minus_one_total)}
              year_minus_two_total={parseFloat(item.year_minus_two_total)}
              monthly_total={parseFloat(item.monthly_total)}
            />
          ))}
        </tbody>
      </Table>
    );
  }

  componentDidMount() {
    this.loadResidualIncomeContext();
  }

  loadResidualIncomeContext() {
    const { app } = this.props;
    APIClient.get(`/loan_applications/${app.id}/hurdles/residual_income`).then((resp: any) => {
      this.setState({
        monthlyResidualIncome: Number(resp.residual_income_context.monthly_residual_income),
      });
    });
  }

  renderResidualIncomeSummary() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Residual Income</th>
            <th />
            <th />
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Monthly Residual Income of</td>
            <td>
              <Money value={this.state.monthlyResidualIncome} />
            </td>
            <td>&gt;</td>
            <td>
              <Money value={1500} />
            </td>
            <td>{this.state.monthlyResidualIncome > 1500 ? "YES" : "NO"}</td>
          </tr>
        </tbody>
      </Table>
    );
  }

  render() {
    const { app, hurdle, onHide, hideTitle } = this.props;
    const totalIncome = parseFloat(app.decision.computed_monthly_income);

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide} hideTitle={hideTitle}>
        <div className="income-summary-table__modal-body">
          <h3 className="income_summary_hurdle__total">
            <span>TOTAL MONTHLY INCOME: </span>
            <span className="income_summary_hurdle__total--amount">
              <Money value={totalIncome} />
            </span>
          </h3>
          {this.renderIncomeSummaryTable()}
          {this.renderResidualIncomeSummary()}
        </div>
      </HurdleView>
    );
  }
}

export default connect()(IncomeSummary);
